import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { FiltersOptionsByKey, FiltersValuesByKey } from '@ihme/common/types';
import withQueryParams, {
    WithQueryParamsInjectedProps,
} from '@ihme/common/utility/hoc/with-query-params';
import { withStorage, WithStorageProps } from '@ihme/common/packages/storage';
import { ChartProvider } from '@ihme/common/web/components';

import api from '../../api';
import config from '../../config';

import BreakdownChartFilters from './BreakdownChartFilters';
import BreakdownChart from './BreakdownChart';

const DEFAULT_FILTERS = {
    age_group_id: config.defaultBreakdownAgeGroupId,
    location_id: config.defaultBreakdownLocationId,
    metric_id: config.defaultBreakdownMetricId,
    measure_id: config.defaultBreakdownMeasureId,
    cause_id: config.defaultBreakdownCauseId,
    year: config.defaultBreakdownYear,
};

type Filters = typeof DEFAULT_FILTERS;

type Props = WithStorageProps & WithQueryParamsInjectedProps<Filters> & RouteComponentProps;

type State = {
    refinedGranularity: FiltersOptionsByKey;
    filters: FiltersValuesByKey;
};

class BreakdownChartSection extends React.Component<Props, State> {
    state: State = {
        refinedGranularity: {},
        filters: {},
    };

    onFiltersChange = (prevFilters: FiltersValuesByKey, filters: FiltersValuesByKey) => {
        this.setState({ filters });

        const { age_group_id } = filters;

        if (prevFilters.age_group_id !== age_group_id) {
            api.data.getCauseOutcomeFilters({ age_group_id })
                .then( (refinedGranularity: FiltersOptionsByKey ) => {
                    this.setState({ refinedGranularity });
                })
                .catch(console.log);
        }
    };

    render() {
        const { location, history, queryParams, cached } = this.props;
        const { refinedGranularity } = this.state;

        return (
            <ChartProvider
                loadFilters={cached(api.data.getCauseOutcomeFilters)}
                loadData={api.data.getCauseOutcomeRecords}
                onFiltersChange={this.onFiltersChange}
                onDataChange={(filters, setFilters) => {
                    const currentMeasureId = this.state.filters
                        ? this.state.filters.measure_id
                        : null;
                    const newMeasureId = filters.measure_id;
                    if (
                        newMeasureId !== currentMeasureId &&
                        newMeasureId === config.maternalMortalityRatioMeasureId.toString()
                    ) {
                        setFilters(
                            {
                                age_group_id: config.tenToFiftyFourAgeGroupId.toString(),
                                metric_id: config.rateMetricId.toString(),
                            },
                            true
                        );
                    }
                }}
                defaultFilters={DEFAULT_FILTERS}
                initialFilters={queryParams}
                history={history}
                location={location}
            >
                <BreakdownChartFilters refinedGranularity={refinedGranularity} />
                <BreakdownChart />
            </ChartProvider>
        );
    }
}

export default withStorage(withQueryParams(withRouter(BreakdownChartSection)));
